
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./../assets/base_logo.png";
import "./../Styles/SplashScreen.css";
import WelcomeInfoModal from "./WelcomeInfoModal";

const SplashScreen = ({ onLoadingComplete }) => {
  const [splashVisible, setSplashVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Show splash for 2.5 seconds, then open the welcome modal
    const timer = setTimeout(() => {
      setSplashVisible(false);
      if (onLoadingComplete) {
        onLoadingComplete();
      }
      setShowModal(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, [onLoadingComplete]);

  // Splash is still showing
  if (splashVisible) {
    return (
      <div className="splash-screen">
        <div className="splash-content">
          <div className="logo-container">
            <img src={logo} alt="Food You'd Cook Logo" className="splash-logo" />
          </div>
        </div>
      </div>
    );
  }

  // After splash — navigate directly to /home
  navigate("/home");
  return null;

  // Commented out: show welcome modal after splash
  // return <WelcomeInfoModal isOpen={showModal} />;
};

export default SplashScreen;